import React, {useState, useEffect } from 'react';
import { f7,Page, Icon, Link, Button } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';

const OrderDetailsPage = ({ f7route }) => {
  const { eid } = f7route.params;
  const [data, setOrderDetails] = useState([]);  
  const [item, setOrderItem] = useState([]); 
  const [showOrderHis, setShowOrderHis] = useState([]); 
  useEffect(() => {
    axios.get(API_BASE_URL + 'orders', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: {
            rest_id: localStorage.getItem('id'),
            id:eid,
            
          }
      })
      .then(response => { 
            setOrderDetails(response.data.data);
            setOrderItem(response.data.data.item);
        })
      .catch(error => console.log(error));
      
  }, [eid]);
  console.log(data.length);

  useEffect(() => {
    
    showOrderStatus(eid);

  },[eid])

  const showOrderStatus = (id) => {
    axios.get(API_BASE_URL + 'orderhistory' , {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params:{
           order_id:id,
        }
      })
      .then(response => { 
        setShowOrderHis(response.data.data);
        })
      .catch(error => console.log(error));
  }
const Payment = (order_id) =>{
  console.log(order_id);
  f7.views.main.router.navigate({ 
    name: 'payment',
    params: {
      id:order_id,
    }
   });
}   

  const renderIcon = (orderStatus) => {
      if (orderStatus === 1) {
        return <img class="img-fluid icon step-1" src={require("./../images/svg/cube.svg").default} alt="cube"/>;
      } else if (orderStatus === 2) {
        return <img class="img-fluid icon step-3" src={require("./../images/svg/bike.svg").default} alt="bike"/>;
      } else if (orderStatus === 3) {
        return <img class="img-fluid icon step-2" src={require("./../images/svg/manage-payment.svg").default} alt="3d-cube"/>;
      } else if (orderStatus === 4) {
        return <img class="img-fluid icon step-4" src={require('./../images/svg/done.svg').default} alt="done"/>;
      // } else if (orderStatus === 5) {
      //   return <img class="img-fluid icon step-1 bg-danger" src={require('./../images/svg/empty-cart.svg').default} alt="done"/>;
      } else {
        return null; // Render a default icon or nothing if no matching status
      }
  };

  return (
    <Page className='bg-white'>
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon> <span className='text-dark d-none d-md-block'>Back</span></Link>
                <h2>Event Details</h2>                
              </div>
            </div>
          </header>
            {data.map(item => ( 
            <section className='profile-form mt-3'>
              <div className="custom-container p-0">        
                <div class="title">
                  <h5 className="fw-bold dark-text dark-text"><span className="light-text">Event ID : </span> {item.event_id}</h5>
                  <a href="#" className='text-muted text-1'>{item.bid_start_date}</a>
                </div>
                <div className='apply-coupon mt-3'>
                  <h5>Status: <span className='text-success'>{ item.order_status_text }</span></h5>
                </div>
                <table className="table 1table-borderless mt-2 text-2">        
                  <tbody>
                    <tr>
                      <td width={'40%'}>Event Name: </td>
                      <td><b>{item.event_name}</b></td>
                    </tr>
                    <tr>
                      <td width={'40%'}>Event Date : </td>
                      <td>{item.event_date}</td>
                    </tr>
                    <tr>
                      <td>Event Size: </td>
                      <td>Adults - <strong>{item.event_adult_size}</strong>, Kids - <strong>{item.event_kids_size}</strong></td>
                    </tr>
                    <tr>
                      <td>Food Need By Time: </td>
                      <td>{item.event_time}</td>
                    </tr>
                    <tr>
                      <td>Event Address: </td>
                      <td>{item.add_lin_1} {item.add_lin_2} {item.city} {item.state} {item.zip_code}</td>
                    </tr>
                    <tr>
                      <td>Event Notes: </td>
                      <td>{item.event_note}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="custom-container p-0">
                <h3 className="fw-bold dark-text">Menu Items</h3>
                <table className="table table-striped table-sm text-2 mt-2">
                  <tbody>
                  {item?.item.map((items, index) => (
                    <tr>
                      <td width={'10%'} className='text-center'>{index + 1}. </td>
                      <td><h5 className="dark-text fw-bold mb-1 text-capitalize">{items.menu_name}</h5> Qty :{items.qty}, 
                      <br/>Total:{items?.total_amount}, 
                      <br/>Note: {items.note}</td>                
                    </tr>              
                  ))}
                  </tbody>
                </table>
              </div> 
              <section>
                <div class="custom-container p-0">
                    {/* <div class="title"> */}
                        {/* <h5 class="dark-text"><span class="light-text">Order ID : </span>{item.order_id}</h5> */}
                        {/* <a href="#"><Button fill small className="text-white btn-success filter-button mt-1 text-1" popupOpen=".demo-popup"> Update Order Status</Button></a>
                    </div> */}
                    <div class="order-tracking mt-3">
                        <ul class="tracking-place">
                        {
                        showOrderHis.length > 0 ? 
                        showOrderHis.map((items, index) => (

                        <li className= "active" >
                            <h6>{items.time}</h6>
                            <span></span>
                            {renderIcon(items.order_status_id)}
                            {/* <img class="img-fluid icon step-1" src={require(`./../images/svg/${icon}`).default} alt="cube"/> */}
                            <h6 class="color-1">{items.order_status}</h6>
                            <h6 class="color-1">{items.message}</h6>
                        </li>
                        )):<div>Order Have No History</div>
                      }

                        
                        {/* <li className={preparation ? "active":""}>
                            <h6>12 : 30 PM</h6>
                            <span></span>
                            <img class="img-fluid icon step-2" src={require(`./../images/svg/3d-cube.svg`).default} alt="3d-cube"/>

                            <h6 class="color-2">Preparing food</h6>
                        </li>
                        <li className={onTheWay ? "active": ""}>
                            <h6>12 : 30 PM</h6>
                            <span></span>
                            <img class="img-fluid icon step-3" src="assets/images/svg/bike.svg" alt="bike"/>

                            <h6 class="color-3">Food on the way</h6>
                        </li>
                        <li className={delivery ? "Active": ""}>
                            <h6>12 : 30 PM</h6>
                            <span></span>
                            <img class="img-fluid icon step-4" src="assets/images/svg/done.svg" alt="done"/>

                            <h6 class="color-4">Delivery to you</h6>
                        </li> */}
                        </ul>
                    </div>
                </div>
              </section>
              <div className="custom-container p-0">
                {item.order_status == 0 ?(
                  <Button className="btn theme-btn w-100" onClick={() => Payment(item.id)} large type="submit">Pay</Button>
                ) :''}
              </div>
            </section>
            ))}
        </div> 
      </div> 
    </Page>
  );
}

export default OrderDetailsPage;